import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function About() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-10%', '10%']);
  return <section id="about" ref={ref} className="py-32 md:py-44 bg-cream text-charcoal overflow-hidden" data-id="element-11">
      <div className="container mx-auto px-6 md:px-12" data-id="element-12">
        <div className="flex flex-col lg:flex-row items-center gap-20 lg:gap-32" data-id="element-13">
          <div className="w-full lg:w-1/2 order-2 lg:order-1" data-id="element-14">
            <FadeIn direction="right" data-id="element-15">
              <div className="overflow-hidden h-[300px] md:h-[500px]" data-id="element-16">
                <motion.img src="https://code-11.hr/wp-content/uploads/elementor/thumbs/Screenshot-2026-01-29-at-12.30.47-rid7vtsvw42cixslyhpe5scbob72qo032e7oar2eki.png" alt="Code 11 wedding venue" className="w-full h-[120%] object-cover object-center origin-center" style={{
                y
              }} data-id="element-17" />
              </div>
            </FadeIn>
          </div>

          <div className="w-full lg:w-1/2 order-1 lg:order-2" data-id="element-18">
            <FadeIn direction="left" delay={0.2} data-id="element-19">
              <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-20">
                The Venue
              </span>
              <div className="w-8 h-[1px] bg-copper mb-8" data-id="element-21"></div>
              <h2 className="text-3xl md:text-4xl font-serif mb-10 leading-tight font-normal" data-id="element-22">
                A Mediterranean <br data-id="element-23" />
                <span className="italic text-charcoal/60" data-id="element-24">Fairytale</span>
              </h2>
              <div className="space-y-6 font-sans text-charcoal/70 leading-relaxed text-base font-light max-w-md" data-id="element-25">
                <p data-id="element-26">
                  Nestled in the heart of Croatia, Code 11 Restaurant offers an
                  unforgettable setting for your most special day. Experience
                  culinary excellence paired with an ambiance that speaks of
                  timeless elegance and modern luxury.
                </p>
                <p data-id="element-27">
                  Our dedicated team ensures every detail is crafted to
                  perfection. From the first consultation to the final toast, we
                  are committed to translating your unique love story into a
                  flawless celebration.
                </p>
              </div>

              <Link to="/weddings-pricing" className="group inline-flex items-center gap-3 mt-10 px-8 py-4 border border-charcoal text-charcoal hover:bg-charcoal hover:text-cream transition-all duration-500 font-sans text-xs uppercase tracking-[0.2em]" data-id="element-28">
                <span data-id="element-29">Explore Packages & Menus</span>
                <ArrowRight className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-1" strokeWidth={1.5} data-id="element-30" />
              </Link>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}